<div mat-dialog-title class="matDialogTitle" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <mat-progress-bar mode="indeterminate" [hidden]="!loading" class="detaile"></mat-progress-bar>
    <span>
        <span>خرید کالا</span>
    </span>
    <span (click)="close()">
        <mat-icon class="close">close</mat-icon>
    </span>
</div>

<form [formGroup]="form1_group" (ngSubmit)="check_access(type_task)">
    <div mat-dialog-content class="matDialogContent">
        <div class="row pe1">

            <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pe div_panding'>
                <label for="material" class='wh-label'>
                    <span (click)="reset_input(171)" [hidden]="type_task == 2">
                        <mat-icon class="close" class="input_search input_search_pe">close</mat-icon>
                    </span>
                    <span> عنوان کالا </span>
                    <span (click)="add_material()" [hidden]="type_task == 2">
                        <mat-icon class="add-icon fleft">
                            add </mat-icon>
                    </span>
                    <input class="wh-input" formControlName="material_title" (click)="get_materials()" required readonly
                        placeholder="برای مشاهده لیست کالا ها کلیک کنید">
                    <input class="wh-input" formControlName="material" [hidden]="true" required readonly>
                </label>
            </div>

            <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pe div_panding'>
                <label for="group" class='wh-label'>
                    <span> گروه | زیر گروه | کد کالا </span>
                    <input class="wh-input" formControlName="group_title" required readonly>
                </label>
            </div>

            <div class='col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 pe div_panding'>
                <label for="cost" class='wh-label'>
                    <span> قیمت خرید </span>
                    <input class='wh-input' formControlName="cost" autocomplete="off" currencyMask required>
                </label>
            </div>

            <div class='col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 pe div_panding'>
                <label for="discount" class='wh-label'>
                    <span> تخفیف </span>
                    <input class='wh-input' formControlName="discount" autocomplete="off" currencyMask required>
                </label>
            </div>

            <div class='col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 pe div_panding'>
                <label for="number" class='wh-label'>
                    <span> تعداد خرید </span>
                    <input class='wh-input' formControlName="number" autocomplete="off" required
                        style="background: #cbf3c3;">
                </label>
            </div>

            <div class='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 pe div_panding'>
                <label for="comment" class='wh-label'>
                    <span> توضیحات </span>
                    <input class="wh-input" formControlName="comment">
                </label>
            </div>

        </div>
    </div>

    <div mat-dialog-actions class="matDialogActions">
        <button type="submit" [disabled]="!form1_group.valid || loading" class="btn_pe">
            <span>ذخیره</span>
        </button>
    </div>
</form>